module.exports = __webpack_public_path__ + "img/image-01.6dc9610e.jpg";